var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('embed',{staticClass:"embed",attrs:{"src":"https://drowningreport.ddc.moph.go.th/drowningdashboard/public/index.php/deathcert"}})])
}]

export { render, staticRenderFns }